import type { ReactNode } from "react";
import styles from "./InputShell.module.scss";

type InputShellProps = {
  label: string;
  focused?: boolean;
  filled?: boolean;
  disabled?: boolean;
  /** truthy면 shellError 클래스로 빨간 border 활성화. 디자인 정책상 텍스트는 렌더되지 않음. */
  error?: string;
  className?: string;
  contentClassName?: string;
  onClick?: () => void;
  children: ReactNode;
};

const cx = (...classes: Array<string | false | undefined | null>) =>
  classes.filter(Boolean).join(" ");

const InputShell = ({
  label,
  focused = false,
  filled = false,
  disabled = false,
  error,
  className,
  contentClassName,
  onClick,
  children,
}: InputShellProps) => {
  const isCompact = focused || filled;
  const handleClick = disabled ? undefined : onClick;

  return (
    <div className={cx(styles.wrap, className)}>
      <div
        className={cx(
          styles.shell,
          focused && styles.shellFocused,
          disabled && styles.shellDisabled,
          error && styles.shellError,
        )}
        onClick={handleClick}
        role={handleClick ? "presentation" : undefined}
      >
        <span className={cx(styles.label, isCompact && styles.labelCompact)}>
          {label}
        </span>
        <div className={cx(styles.content, contentClassName)}>{children}</div>
      </div>
    </div>
  );
};

export default InputShell;
export type { InputShellProps };
